import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useDealsStore} from "../../store/deals.store";

export const useDeal = () => {
    const setDeal = useDealsStore((state) => state.setDeal);

    return useMutation(PartnerApi.deal, {
        onSuccess: (data) => {
            setDeal(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};